
import { mapGetters, mapActions } from 'vuex';
export default {
	components: {
		breadcrumbs		: () => import('../../components/pages/breadcrumbs.vue'),
		vcDynamicLink	: () => import('../../components/pages/dynamic-link.vue')
	},
	data(){
		return {
			searchLead: "",
			findAgent: null,
			profile_image: null
		}
	},
	mounted(){
	},
	computed: {
		...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang',
			getterBasicData: 'getterBasicData',
			getterCustomerLeadAgent: 'getterCustomerLeadAgent'
		}),
		getAgent(){
			return this.findAgent;
		},
		getAllPhones(){
			return ( this.getterBasicData?.contact_information.phones || [] ).reduce( (previous_item, current_item, current_index, original_array) =>{
				
				if( current_item.call ){
					previous_item.push({ call: true, number: current_item.number, format: current_item.format });
				}
				if( current_item.sms ){
					previous_item.push({ sms: true, number: current_item.number, format: current_item.format });
				}
				if( current_item.whatsapp ){
					previous_item.push({ whatsapp: true, number: current_item.number, format: current_item.format });
				}
				if( current_index === original_array.length - 1 ){
					previous_item = previous_item.filter( (item) => item.call ).concat( previous_item.filter( (item) => item.sms ) ).concat( previous_item.filter( (item) => item.whatsapp ) );
				}
				return previous_item;
			}, []);
		}
	},
	methods: {
		...mapActions({
			findCustomerLeadAgent: 'findCustomerLeadAgent'
		}),
		async searchAgent(){
			
			await this.findCustomerLeadAgent({ email: this.searchLead }).then( (result_agent) => {
				
				this.findAgent = this.getterCustomerLeadAgent?.agent;
				if( this.findAgent ){
					
					if( this.findAgent === null || this.findAgent.photo === '' ){
						
						this.profile_image = `${ this.$config.hefesto_file.baseURL }/images/svg-store/svg-profile-image/svg-secondary.svg`;
					}
					else{
						
						this.profile_image = `${ this.$config.agent.baseURL.replace('/api', '') }/${ this.findAgent.photo.replace('public/', '') }`;
					}
					this.hide_profile = false;
					this.findAgent.phone = this.findAgent.phone ? this.findAgent.phone : '';
					this.findAgent.whatsappLink = this.findAgent.phone != '' ? `https://api.whatsapp.com/send?phone=${ this.findAgent.phone.replace(/ +/g, '').replace('+', '') }` : '';
				}
				this.$refs['modal_agent'].show();
			});
		},
		cleanSearchAgent(){
			this.searchLead = "";
		}
	}
}
